import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { NotificationApiService } from '../../services/notification/notification-api.service';
import { NotificationItemModel } from '../../models/notification-item.model';

export type NotificationTab = 'all' | 'archived';

@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.css'],
})
export class NotificationBellComponent implements OnInit {
  notifications: NotificationItemModel[] = [];
  showDropdown = false;
  activeTab: NotificationTab = 'all';

  constructor(
    private readonly notificationApi: NotificationApiService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
  }

  get unreadCount(): number {
    return this.notifications.filter((n) => !n.read && !n.archived).length;
  }

  get visibleNotifications(): NotificationItemModel[] {
    if (this.activeTab === 'archived') {
      return this.notifications.filter((n) => n.archived);
    }
    return this.notifications.filter((n) => !n.archived);
  }

  switchTab(tab: NotificationTab): void {
    this.activeTab = tab;
  }

  archiveNotification(
    event: MouseEvent,
    notification: NotificationItemModel,
  ): void {
    event.stopPropagation();
    notification.archived = true;
    notification.read = true;
  }

  loadNotifications(): void {
    this.notificationApi.getNotifications().subscribe({
      next: (items) => (this.notifications = items),
      error: () => (this.notifications = []),
    });
  }

  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }

  onNotificationClick(notification: NotificationItemModel): void {
    if (!notification.read) {
      this.notificationApi.markAsRead(notification.id).subscribe(() => {
        notification.read = true;
      });
    }
    this.showDropdown = false;
    if (notification.link) {
      this.router.navigateByUrl(notification.link);
    }
  }

  markAllAsRead(): void {
    this.notificationApi.markAllAsRead().subscribe(() => {
      this.notifications
        .filter((n) => !n.archived)
        .forEach((n) => (n.read = true));
    });
  }

  iconClass(type: NotificationItemModel['type']): string {
    switch (type) {
      case 'danger':
        return 'fa-solid fa-circle-exclamation text-danger';
      case 'warning':
        return 'fa-solid fa-triangle-exclamation text-warning';
      default:
        return 'fa-solid fa-circle-info text-info';
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.notification-bell-wrapper')) {
      this.showDropdown = false;
    }
  }
}
